/**
 * @overview 菜单编辑
 * @author 3173
 * @date 2019-1
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '../../../../tool'
let { WizContainer, WizAvatarUpload, modelUtils, ossFileUtils } = framework_tool;
let { WizCard, WizInput, WizForm, Wizmessage, WizTooltip, WizIcon } = component_tool;
let { Session } = utils_tool;
import { Spin } from 'antd'

import cx from 'classnames';
class MenuDetail extends WizContainer {

  componentName = 'MenuDetail';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/auth/menu/menuDetailUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('menuRecord', initialValue)
      } else {
        initialValue = Session.get('menuRecord') || {};
      }
    }
    this.state = {
      name: null,
    }
    this.initialValue = initialValue;
  }

  _componentDidMount() {
    const { history } = this.props;
    let menuId = this.initialValue.id ? this.initialValue.id : null;
    this.doActions([
      {
        path: 'menu/getMenus',
        payload: {
          key: 'menu_getMenusForTpye',
          apiParams: {
            type: 0,
            neIds: menuId ? [menuId] : null
          }
        },
        requireLoading: true,
      },
      {
        path: 'elements/listByCondition',
        payload: {
          key: 'menu_getelements',
          apiParams: {
            state: 1
          }
        },
        requireLoading: true,
      }
    ])

  }

  propsAndStateOnChange = {
    addMenu: this._addMenuOver.bind(this),
    // menuElements: this._pushElementsData.bind(this)
  }

  _addMenuOver(nextProps, nextState) {
    if (nextProps.addMenu.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/auth/menu');
    } else {
      wizNotice.error('提交失败：' + nextProps.addMenu.msg);
    }
    return true;
  }

  // _pushElementsData(nextProps, nextState) {
  //   return true;
  // }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    if (fitterValues && fitterValues['icon'] && fitterValues['icon'].length) {
      fitterValues.icon = fitterValues.icon[0].fileId;//icon获取对应上传实体的fileId
    } else {
      fitterValues.icon = "";
    }
    return fitterValues;
  }

  /**保存菜单 */
  _saveMenu(values) {
    const { history } = this.props;
    let apiPath = "menu/addMenu";
    if (history.location && history.location.pathname === '/auth/menu/menuDetailUpd') {
      apiPath = "menu/updateMenu"
    }
    let fitterValues = this.fitterFieldsValue(values)
    this.doAction({
      path: apiPath,
      payload: {
        key: "addMenu",
        apiParams: {
          menu: fitterValues,
          elementIds: fitterValues.elements
        }
      }
    });
  }

  _render() {
    const { history } = this.props;
    let cardTitle = '新增';
    let initialValue = this.initialValue

    if (Session.get('menuRecord') && history.location && history.location.pathname === '/auth/menu/menuDetailUpd') {
      //let menuRecord = Session.get('menuRecord');
      cardTitle = '编辑';
    //  initialValue = menuRecord;
    }

    let menuElements = this.props.menuElements ? this.props.menuElements : [];

    let columns = [
      {
        formItem: {
          type: "hidden",
          initialValue: initialValue.id
        },
        name: "id"
      },
      {
        title: "菜单名称",
        name: "name",
        dataIndex: "name",
        formItem: {
          maxlength: 15,
          placeholder: '菜单名称最多输入15个字',
          rules: [{
            required: true,
            message: '请输入菜单名称',
          },
          {
            pattern: /^[A-Za-z\d_\-\u4e00-\u9fa5]{1,15}$/,
            message: '菜单名称不允许使用特殊符号'
          }
          ],
          initialValue: initialValue.name
        },
      },
      {
        title: "编号",
        name: "number",
        dataIndex: "number",
        formItem: {
          maxlength: 64,
          placeholder: '编号不允许重复，菜单顺序按照编号进行排序',
          rules: [{
            required: true,
            message: '请输入编号',
          },
          {
            pattern: /^[A-Za-z0-9-_]+$/,
            message: '编号仅支持数字、字母、-、_'
          }],
          initialValue: initialValue.number
        },
      },
      {
        title: "上级菜单",
        name: "parentId",
        dataIndex: "parentId",
        // formItem: {
        //   type: 'select',
        //   initialValue: initialValue.parentId && initialValue.parentId != 0 ? initialValue.parentId : null,
        //   allowClear: true
        // },
        //dict: this.props.folderMenus
        dict: this.props.folderMenus,
        formItem: {
          type: 'treeselect',
          initialValue: initialValue.parentId && initialValue.parentId != 0 ? initialValue.parentId : null,
          allowClear: true,
          
        },
      },
      {
        title: "类型",
        name: "type",
        dataIndex: "type",
        formItem: {
          type: 'select',
          rules: [{
            required: true,
            message: '请选择类型',
          }],
          initialValue: initialValue.type
        },
        dict: [//需要文件夹类型的菜单数据
          { code: 0, codeName: "文件夹" },
          { code: 1, codeName: "菜单" }
        ],
      },
      {
        title: "菜单链接",
        name: "url",
        dataIndex: "url",
        formItem: {
          maxlength: 200,
          placeholder: '菜单链接最多输入200个字符',
          initialValue: initialValue.url,
          rules: [
            {
              pattern: /^[-A-Za-z0-9+&@#/%=~_|.:?]+$/,
              message: '菜单链接不合法'
            }],
        },
      },

      menuElements.length > 0 ? {
        title: "菜单元素",
        name: "elements",
        dataIndex: "elements",
        formItem: {
          type: 'transfer',
          showSearch: true,
          dataSource: menuElements,//[{ key: 1, title: "A" }, { key: 2, title: "B" }],
          initialValue: initialValue.elementIds ? initialValue.elementIds : [],
          titles: ['可选元素', '已选元素'],
          listStyle:{ height:260}
        }
      } : {},
      {
        title: "上传图标",
        name: "icon",
        dataIndex: "icon",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            record = initialValue;
            const { getFieldDecorator } = form;
            let icon = null;
            let fileName = null;
            let fileMimeType = null;
            let fileSize = null;
            let fileUri = null;
            if (record != null && record.icon != null && record.icon != null) {
              icon = record.icon;
              fileName = record.fileName;
              fileMimeType = record.fileMimeType;
              fileSize = record.fileSize;
              fileUri = record.fileUri;
            }
            return (
                  getFieldDecorator('icon', {
                    initialValue:
                      (record && record.icon) ? [
                        {fileId:record.icon}
                      ] : []
                  })(
                    <WizAvatarUpload
                      accept={'.jpg, .jpeg, .png'}
                      listType={'picture-card'}
                      aspectRatio={1 / 1}
                      beforeUpload={(file) => {
                        let result = true;
                        const isLt1M = file.size / 1024 / 1024 < 0.975; //1M
                        if (file.type.indexOf('image/') == -1) {
                          Wizmessage.error('只能上传图片类型,请重新选择!');
                          result = false;
                        } else if (!isLt1M) {
                          Wizmessage.error('图片不得超过1M!');
                          result = false;
                        }
                        return result;
                      }}
                    />
                  )
             )
          }
        },
        tableItem: {
          /* render: (text, record) => {
             let url = ossFileUtils.getOssFile(
               record.icon,
               record.fileName,
               record.fileMimeType,
               record.fileSize,
               record.fileUri,
             ).url
             url = record.fileUri ? url : constants.files.sys_img_loadingFailedSmall;
             return <div style={{ display: 'flex', 'justify-content': 'flex-start',  marginRight: 0, }}>
               <div>
                 <img height={30} width={30} src={url} />
               </div>
             </div>
           }*/
        }
      },
      {
        title: "介绍",
        name: "remark",
        dataIndex: "remark",
        formItem: {
          type: 'textarea',
          maxlength: 100,
          initialValue: initialValue.remark,
          placeholder: '介绍最多输入100个字符',
        }
      },
      {
        title: "是否展示",
        name: "exhibition",
        dataIndex: "exhibition",
        formItem: {
          type: 'Radio',
          rules: [{
            required: true,
            message: '请选择类型',
          }],
          initialValue: initialValue.exhibition==0 ? initialValue.exhibition : 1
        },
        dict: [//需要文件夹类型的菜单数据
          { code: 1, codeName: "是" },
          { code: 0, codeName: "否" }
        ],
      },
      {
        title: "状态",
        name: "disabled",
        dataIndex: "disabled",
        formItem: {
          type: 'Radio',
          rules: [{
            required: true,
            message: '请选择类型',
          }],
          initialValue: initialValue.disabled ? initialValue.disabled : 0
        },
        dict: [//需要文件夹类型的菜单数据
          { code: 0, codeName: "有效" },
          { code: 1, codeName: "无效" }
        ],
      },
      {
        title: "顺序",
        name: "orderNumber",
        dataIndex: "orderNumber",
        tableItem: {},
        formItem: {
          type: 'number',
          initialValue: initialValue.orderNumber,
          min:1,
          max:99,
          precision:0,
          rules: [{
            required: true,
            message: '请输入顺序',
          }],
        }
      }
    ]

    let onSubmit = this._saveMenu.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      },
      style: { width: '100%' }
    }
    return (
      <Spin tip={'加载中'} spinning={this.props.elementsLoading || this.props.menuLoading}>
        <WizCard>
          <WizForm className={'form-inline'} {...formProps} />
        </WizCard>
      </Spin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { menu, elements } = state;
  const folderMenus = modelUtils.getModelEntity(menu, "menu_getMenusForTpye");
  const addMenu = modelUtils.getModelEntity(menu, "addMenu");
  const menuElements = modelUtils.getModelEntity(elements, "menu_getelements");
  const load = modelUtils.getLoadingState(state, ['elements', 'menu']);
  return {
    folderMenus: folderMenus.data,
    addMenu: addMenu,
    menuElements: menuElements.data,
    ...load
  }
};

export default connect(mapStateToProps)(MenuDetail);
